const replaceSymbolsCombinationsWithLetters = (word) =>
  word
    .replace(/\(\)/gm, 'o')
    .replace(/\|_/gm, 'l')
    .replace(/\|\\\|/gm, 'n')
    .replace(/\\\//gm, 'v')
    .replace(/vv/gim, 'w');

export default replaceSymbolsCombinationsWithLetters;
